<template>  
  <div v-if="showAlert" :class="[{'show': showAlert}, 'bottombox']">  
    <div class="bottompostion">  
      <div class="oldldicon"></div>  
      <div class="bottomContent">  
        <div class="bottomTitle">{{ currentMsg.types }}</div>  
        <div class="bottomnr">{{ currentMsg.title }}</div>  
      </div>  
      <div class="bztx" @click="closeAlert">  
        <span class="bztxtext">不再提醒</span>  
        <i class="cloneicon"></i>  
      </div>  
    </div>  
  </div>  
</template>  
  
<script>  
import api from '@/api'
export default {  
  data() {  
    return {  
      showAlert: false,  
      currentMsg: {}  
    };  
  },  
  methods: {  
    mCloseMessage(val){
      this.showAlert = val;
    },
    showMessage(msg) {  
      console.log(123456,msg);
      this.currentMsg = msg;  
      this.showAlert = true;  
      console.log(this.showAlert);
      
      // 使用 setTimeout 模拟弹窗显示时间，之后自动关闭（可选）  
      // setTimeout(() => {  
      //   this.closeAlert();  
      // }, 5000); // 5秒后自动关闭  
    },  
    closeAlert() {  
      // 调用接口关闭消息，并关闭弹窗  
      this.$emit('close-alert');  
      this.showAlert = false;  
      // 假设 EditRead 接口需要一个 message ID 来标记哪个消息被读取  
      this.axios.post(api.EditRead, { id: this.currentMsg.id })  
        .then(res => {  
          console.log('消息已标记为已读', res);  
        })  
        .catch(err => {  
          console.error('标记消息为已读失败', err);  
        });  
    }  
  }  
};  
</script>  
  <style lang="less">
  .bottombox {
        position: fixed;
        right: -420px;
        bottom: 20px;
        width: 400px;
        min-height: 160px;
        background-color: #ff546c;
        border-radius: 5px;
        transition:opacity .5s,right .5s ;
        opacity: 0;
        z-index: -1;
        .bottompostion {
          width: 100%;
          height: 100%;
          position: relative;
          padding: 26px 20px 10px 30px;
          display: flex;
          .oldldicon {
            width: 94px;
            height: 120px;
            background: url(../assets/oldldicon.png) no-repeat;
            background-size: 100% 100%;
            margin-right: 10px;
          }
          .bottomContent {
            flex: 1;
            .bottomTitle {
              font-size: 16px;
              color: #ffffff;
              margin-bottom: 10px
            }
            .bottomnr {
              overflow: hidden;
              width: 240px;
              // height: 70px;
              font-size: 14px;
              color: #ffffff;
            }
          }
          .bztx {
            position: absolute;
            top: 2px;
            right: 30px;
            cursor: pointer;
            .bztxtext {
              font-size: 14px;
              color: #ffffff;
              text-decoration: underline;
            }
            .cloneicon {
              display: inline-block;
              width: 14px;
              height: 14px;
              background: url(../assets/cloneicon.png) no-repeat;
              background-size: 100% 100%;
              margin-left: 10px;
            }
          }
        }
      }
      .show {
        right: 0;
        z-index: 8;
        opacity:1;
      }
  </style>


// WEBPACK FOOTER //
// src/components/MessageAlert.vue